export default __webpack_public_path__ + "static/media/bg-dota-1.8d5c1c6f.png";